import React from 'react';
import LineChart from 'react-linechart';
import { useSelector } from 'react-redux';
import { selectSelectedCellId } from 'selectors/ordersSelector';
import { espooCellId } from '../../../constants';
import {
  fetchElevationDataForRoute,
  parseRouteIntoGraphLines,
  checkIfRouteHasElevationData,
  getGraphLinesWithRelAlt
} from 'hooks/routePlannerHooks';

const RouteConfirmationGraph = ({ geoJson, height, width = 650 }) => {
  const [graphLines, setGraphLines] = React.useState(null);
  const [shouldShowAltitudeWarning, setShouldShowAltitudeWarning] = React.useState(false);
  const selectedCellId = useSelector(selectSelectedCellId);

  React.useEffect(() => {
    let isMounted = true;

    const loadGraphLines = async () => {
      if (!geoJson) {
        if (isMounted) {
          setGraphLines(null);
          setShouldShowAltitudeWarning(false);
        }
        return;
      }

      try {
        let baseLines;
        const hasElevationData = checkIfRouteHasElevationData(geoJson);
        if (hasElevationData) {
          baseLines = parseRouteIntoGraphLines(geoJson, 0);
        } else {
          baseLines = await fetchElevationDataForRoute(geoJson, 0);
        }

        const withRelAlt = getGraphLinesWithRelAlt(
          baseLines.groundGraphLine,
          baseLines.droneGraphLine
        );

        if (isMounted) {
          setGraphLines(withRelAlt);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    };

    loadGraphLines();
    return () => {
      isMounted = false;
    };
  }, [geoJson]);

  React.useEffect(() => {
    const maxElevationInGeofence = 150;
    if (graphLines?.droneGraphLine) {
      const showWarning =
        selectedCellId === espooCellId &&
        graphLines.droneGraphLine.some(point => point.y >= maxElevationInGeofence);
      setShouldShowAltitudeWarning(showWarning);
    } else {
      setShouldShowAltitudeWarning(false);
    }
  }, [graphLines, selectedCellId]);

  return (
    <div className={shouldShowAltitudeWarning ? 'bg-red-50 border border-1 border-red-200' : ''}>
      {graphLines && shouldShowAltitudeWarning ? (
        <p className="ml-3 mt-1 text-red-900">Warning: Max drone elevation exceeds the geofence limit</p>
      ) : null}
      <LineChart
        hideXLabel
        yLabel=""
        interpolate="linear"
        onPointHover={point => point.y}
        hidePoints={false}
        width={width}
        height={height}
        data={[
          {
            color: 'gray',
            points: [],
            name: 'Planned Alt'
          },
          {
            color: '#0583FF',
            points: graphLines?.droneGraphLine || [],
            name: 'Drone Alt'
          },
          {
            color: '#ED0505',
            points: graphLines?.groundGraphLine || [],
            name: 'Ground'
          }
        ]}
      />
    </div>
  );
};

export default RouteConfirmationGraph;
